import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query AppointmentOverviewGridQuery(
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
    $companyId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        data: Appointments(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $filters
          }
        ) {
          id
          status
          tenant {
            id
            firstname
            lastname
          }
          usageUnit {
            id
            position
          }
          tableId
          referenceNumber
          type
          accessReason
          date
          timeframe
          initiator
          serviceReason {
            id
            name
          }
          executionDate
          lastSuccessfulAccess
        }
      }
    }
  }
`
